import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import {
    ServiceTimeBandUpdateInput
} from '@libs/types/src/services/input-type/services/settings/service-time-band.update-input';
import {
    ServiceTimeBandGridObject
} from '@libs/types/src/services/object-type/service/settings/service-time-band.object';
import {
    ServiceTimeBandCreateInput
} from '@libs/types/src/services/input-type/services/settings/service-time-band.create-input';

@Injectable({ providedIn: 'root' })
export class ServiceTimeBandGqlService extends GqlServiceV2 {

    public getTimeBands(input: GridInput, fragment: string) {
        return this.query<ServiceTimeBandGridObject>(
            `
                query($input: GridInput!) {
                    serviceTimeBand {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createTimeBand(
        input: ServiceTimeBandCreateInput, fragment: string = 'ok',
    ) {
        return this.mutate<OkObject>(
            `
                mutation($input: ServiceTimeBandCreateInput!) {
                    serviceTimeBand {
                        create(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updateTimeBand(
        input: ServiceTimeBandUpdateInput, fragment: string = 'ok',
    ) {
        return this.mutate<OkObject>(
            `
                mutation($input: ServiceTimeBandUpdateInput!) {
                    serviceTimeBand {
                        update(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteTimeBand(input: IdInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    serviceTimeBand {
                        delete(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

}


